// src/sections/privacy/SeedPhraseGrid.tsx

interface Props {
  words: string[];  // exactly 24 words
}

/**
 * SeedPhraseGrid — displays 24 BIP-39 words in a 4-column grid.
 * Each word has its position number (1-indexed).
 * Used in SeedPhraseSetupModal to show user their seed phrase.
 */
export function SeedPhraseGrid({ words }: Props) {
  return (
    <div
      className="grid grid-cols-4 gap-2 p-4 bg-[var(--surface-02)] rounded-md border border-[var(--border-01)]"
      aria-label="Cụm từ khôi phục 24 từ"
      role="list"
    >
      {words.map((word, i) => (
        <div
          key={i}
          role="listitem"
          className="flex items-center gap-1.5 bg-[var(--surface-01)] rounded px-2 py-1.5 text-sm font-mono"
        >
          <span className="text-[var(--text-04)] text-xs w-5 text-right shrink-0 select-none">
            {i + 1}.
          </span>
          <span className="text-[var(--text-01)] font-medium">{word}</span>
        </div>
      ))}
    </div>
  );
}
